/* Rozwijanie listy „pokaż więcej / pokaż mniej".

   Ukrywanie dzieje się dopiero w JS, nie w Liquidzie — bez skryptu
   (i dla robotów indeksujących) widoczne są wszystkie pozycje, a przycisk
   znika. Dzięki temu treść recenzji nigdy nie przepada. */

class BjReveal extends HTMLElement {
  connectedCallback() {
    this.items = Array.from(this.querySelectorAll('[data-bj-item]'));
    this.toggle = this.querySelector('[data-bj-toggle]');
    this.toggleWrap = this.querySelector('[data-bj-toggle-wrap]');
    if (!this.toggle) return;

    this.initial = parseInt(this.dataset.initial, 10) || 6;

    // Nie ma czego rozwijać — chowamy przycisk. Dotyczy też pustej listy,
    // czyli stanu sekcji zanim wejdą prawdziwe recenzje.
    if (this.items.length <= this.initial) {
      this.toggleWrap.hidden = true;
      return;
    }

    this.onToggle = this.onToggle.bind(this);
    this.toggle.addEventListener('click', this.onToggle);

    this.expanded = false;
    this.render();
  }

  disconnectedCallback() {
    this.toggle?.removeEventListener('click', this.onToggle);
  }

  onToggle() {
    this.expanded = !this.expanded;
    this.render();

    // Po zwinięciu lista skacze w górę — przywróć widok na jej początek.
    if (!this.expanded) {
      this.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }
  }

  render() {
    this.items.forEach((item, index) => {
      item.hidden = !this.expanded && index >= this.initial;
    });

    this.toggle.setAttribute('aria-expanded', String(this.expanded));
    this.toggle.textContent = this.expanded
      ? this.toggle.dataset.labelLess
      : this.toggle.dataset.labelMore;
  }
}

if (!customElements.get('bj-reveal')) {
  customElements.define('bj-reveal', BjReveal);
}
